import React, { useEffect, useState } from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Button, Grid, MenuItem, Select, Typography, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Modal from '../common/Modal';
import { QuestionList } from '../common/QuestionList';
import { AddQuestion } from '../common/AddQuestion';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { showProgress } from '../../redux/actions/DealershipActions';
import { ErrorToast, MultipleErrorToast, notifySuccess } from '../utils/Utils';
import { GET_INITIAL_OPTIONS } from '../../constants/exam';
import AntSwitch from '../dailydose/AntSwitch';

const useStyle = makeStyles({
  popupContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  questionBox: {
    height: '60vh',
    overflowY: 'auto',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '10px 20px',
  },

  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  optional_field: {
    color: '#667085',
  },
  inputField: {
    width: '97%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      '-moz-appearance': 'textfield',
    },
  },
  inputFieldTime: {
    width: '70%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      '-moz-appearance': 'textfield',
    },
  },
  select: {
    width: '30%',
    marginTop: '5px',
    padding: '5px 10px ',
    background: '#D0D5DD',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    fontWeight: '600',
  },
});

export function AddPreAssesmentPopup({ isOpen, setIsOpen, isEdit, fetchCollection }) {
  const classes = useStyle();
  const dispatch = useDispatch();

  const collectionInfo = useSelector((state) => state.getCollection.collection);

  const [questions, setquestions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isAddQuestion, setIsAddQuestion] = useState(false);
  const [isQEdit, setIsQEdit] = useState(false);
  const [totalQuestion, setTotalQeustion] = useState(null);
  const [passingScore, setPassingScore] = useState('');
  const [enableAllowSkipJourney, setEnableAllowSkipJourney] = useState(false);

  // add qeustion
  const [journeys, setJourneys] = useState([]);
  const [guides, setGuides] = useState([]);
  const [selectedGuideId, setSelectedGuideId] = useState('');
  const [selectedJId, setSelectedJId] = useState('');
  const [queType, setQueType] = useState('single_select');
  const [queTitle, setQueTitle] = useState('');
  const [options, setOptions] = useState(GET_INITIAL_OPTIONS);
  const [lockTime, setLockTime] = useState(null);
  const [timeUnit, setTimeUnit] = useState('days');
  const LOCK_TIME_UNITS = ['hours', 'days', 'months', 'years'];
  const [dates, setDates] = useState({
    startDate: null,
    endDate: null,
  });

  const handleStartDateChange = (date) => {
    setDates((pre) => ({
      ...pre,
      startDate: date,
    }));
  };
  const handleEndDateChange = (date) => {
    setDates((pre) => ({
      ...pre,
      endDate: date,
    }));
  };

  const handleAllowSkipJourneyChange = (e) => {
    setEnableAllowSkipJourney(e.target.checked);
  };

  const getDetails = async () => {
    dispatch(showProgress(true));

    try {
      const res = await service.get(
        apiEndpoints.COLLECTION_QUESTIONS.replace('ID', collectionInfo.id).replace('TYPE', 'pre_assessment'),
      );
      setPassingScore(res.passingScore || '');
      setTotalQeustion(res.numberQuestions);
      setquestions(res.questions || []);
      setDates({
        startDate: res.startDate || null,
        endDate: res.endDate || null,
      });
      setEnableAllowSkipJourney(res.allowSkipJourneys);
      if (res.lockTime) {
        const parts = res.lockTime.split(' ');
        setLockTime(parts[0]);
        let unit = parts[1];
        // eslint-disable-next-line eqeqeq
        if (parts[0] == '1') {
          unit = `${parts[1]}s`;
        }
        setTimeUnit(unit);
      }
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (isEdit && collectionInfo.id) {
      getDetails();
    }
  }, [collectionInfo]);

  const getJourneys = async () => {
    dispatch(showProgress(true));
    try {
      const result = await service.get(apiEndpoints.COLLECTION_JOURNEYS.replace('ID', collectionInfo.id));
      setJourneys(result || []);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (collectionInfo?.id) {
      getJourneys();
    }
  }, [collectionInfo]);

  useEffect(() => {
    if (selectedJId) {
      const selectedJ = journeys.filter((j) => j.id === selectedJId)[0];
      const guideList = selectedJ ? selectedJ.guides || [] : [];
      setGuides(guideList);
    }
  }, [selectedJId]);

  const checkValidation = () => {
    const errors = [];
    let isValid = true;

    if (!selectedJId) {
      isValid = false;
      errors.push('Please select a journey');
    }

    if (!queTitle || queTitle.trim() === '') {
      isValid = false;
      errors.push('Please enter a question');
    }

    const emptyOptions = options?.filter((op) => !op.title || op.title.trim() === '') || [];
    if (emptyOptions?.length > 0) {
      isValid = false;
      errors.push('Please enter all the options');
    }

    const answerOptions = options?.filter((op) => op.isAnswer) || [];
    if (answerOptions?.length === 0 && queType === 'single_select') {
      isValid = false;
      errors.push('Please select correct option for the question');
    }
    if (answerOptions?.length < 2 && queType === 'multi_select') {
      isValid = false;
      errors.push('Please select atleast two correct options for the question or change the question type');
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return isValid;
  };
  const clearState = () => {
    setSelectedGuideId('');
    setSelectedJId('');
    setQueTitle('');
    setQueType('single_select');
    setOptions(GET_INITIAL_OPTIONS);
    setSelectedIndex(null);
    setIsQEdit(false);
    setEnableAllowSkipJourney(false);
  };

  const onAdd = () => {
    if (!checkValidation()) return;
    const temp = [...questions];
    const que = {
      title: queTitle,
      journeyId: selectedJId,
      type: queType,
      options,
    };
    if (selectedGuideId) {
      que.guideId = selectedGuideId;
    }
    if (isQEdit) {
      const editedQuestion = temp[selectedIndex];
      if (editedQuestion.id && editedQuestion.type === queType) {
        que.id = editedQuestion.id;
      }
      temp[selectedIndex] = que;
      setquestions(temp);
    } else {
      setquestions([...temp, que]);
    }

    clearState();
    setIsAddQuestion(false);
  };

  const getCategorizedQuestions = () => {
    const allQeustions = [...questions];
    const temp = [];
    if (allQeustions && allQeustions.length > 0) {
      allQeustions.forEach((question, indx) => {
        const journeyIndx = temp.findIndex((item) => item.category === question.journeyId);

        if (journeyIndx !== -1) {
          const que = { ...question };
          que.index = indx;
          temp[journeyIndx].questions.push(que);
        } else {
          const que = { ...question };
          que.index = indx;
          temp.push({
            category: question.journeyId,
            questions: [que],
          });
        }
      });
    }
    return temp;
  };

  const handleSubmitValidation = () => {
    const errors = [];
    let isValid = true;

    if (!totalQuestion) {
      isValid = false;
      errors.push('Please enter no. of qeustions in pre assessment');
    } else if (totalQuestion <= 0) {
      isValid = false;
      errors.push('Total questions must be greater than or equal to 1');
    } else if (totalQuestion > questions.length) {
      isValid = false;
      errors.push('The number of configured questions entered is less than the required amount for the assessment.');
    }

    if (lockTime && lockTime <= 0) {
      isValid = false;
      errors.push('Lock Period value must be greater than or equal to 1');
    }
    if (passingScore && passingScore > 100) {
      isValid = false;
      errors.push('Passing Score must be less than or equal to 100');
    }
    if (passingScore && passingScore <= 0) {
      isValid = false;
      errors.push('Passing Score must be greater than or equal to 1');
    }
    if (!dates.startDate) {
      isValid = false;
      errors.push('Please select start date');
    }
    if (!dates.endDate) {
      isValid = false;
      errors.push('Please select end date');
    }
    if (dates.startDate && dates.endDate && dates.endDate < dates.startDate) {
      isValid = false;
      errors.push('End date must be greater than start date');
    }

    const categorizedQues = getCategorizedQuestions();
    if (categorizedQues?.length < journeys?.length) {
      isValid = false;
      errors.push('Please add at least 1 question from each journey');
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return isValid;
  };

  const onSubmit = async () => {
    if (!handleSubmitValidation()) return;
    dispatch(showProgress(true));

    const payload = {
      collectionId: collectionInfo.id,
      numberQuestions: totalQuestion,
      passingScore,
      examType: 'pre_assessment',
      startDate: moment(dates.startDate).format('YYYY-MM-DD'),
      endDate: moment(dates.endDate).format('YYYY-MM-DD'),
      questions,
      allowSkipJourneys: enableAllowSkipJourney,
    };
    if (lockTime) {
      let temp = timeUnit;
      // eslint-disable-next-line eqeqeq
      if (lockTime == '1' && timeUnit.endsWith('s')) {
        temp = timeUnit.slice(0, -1);
      }
      payload.lockTime = `${lockTime} ${temp}`;
    }

    try {
      await service.post(apiEndpoints.COLLECTION_ASSESMENT, payload);
      notifySuccess('Pre-Assesment created successfully');
      fetchCollection();
      setIsOpen(false);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  const onEditSubmit = async () => {
    if (!handleSubmitValidation()) return;
    dispatch(showProgress(true));

    const payload = {
      examId: collectionInfo.preAssessmentId,
      collectionId: collectionInfo.id,
      numberQuestions: totalQuestion,
      passingScore,
      examType: 'pre_assessment',
      questions,
      startDate: moment(dates.startDate).format('YYYY-MM-DD'),
      endDate: moment(dates.endDate).format('YYYY-MM-DD'),
      allowSkipJourneys: enableAllowSkipJourney,
    };

    if (lockTime) {
      let temp = timeUnit;
      // eslint-disable-next-line eqeqeq
      if (lockTime == '1' && timeUnit.endsWith('s')) {
        temp = timeUnit.slice(0, -1);
      }
      payload.lockTime = `${lockTime} ${temp}`;
    }

    try {
      await service.post(apiEndpoints.COLLECTION_ASSESMENT_UPDATE, payload);
      notifySuccess('Pre-Assesment updated successfully');
      fetchCollection();
      setIsOpen(false);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  return (
    <Modal isOpen={isOpen} height="84vh" width="950px">
      <Grid className={classes.popupContainer}>
        <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
          <Grid item>
            <Grid item style={{ fontWeight: '700', fontSize: '18px' }}>
              {isEdit ? 'Edit Pre-Assessment' : 'Add Pre-Assessment'}
            </Grid>
          </Grid>
          <Grid item>
            <CloseIcon onClick={() => setIsOpen(false)} style={{ cursor: 'pointer' }} />
          </Grid>
        </Grid>

        {isAddQuestion ? (
          <AddQuestion
            journeys={journeys}
            guides={guides}
            setSelectedGuideId={setSelectedGuideId}
            setSelectedJId={setSelectedJId}
            selectedJId={selectedJId}
            selectedGuideId={selectedGuideId}
            setIsAddQuestion={setIsAddQuestion}
            queType={queType}
            setQueType={setQueType}
            queTitle={queTitle}
            setQueTitle={setQueTitle}
            options={options}
            setOptions={setOptions}
            isEdit={isQEdit}
            questions={questions}
            selectedIndex={selectedIndex}
            calledFrom="collection"
          />
        ) : (
          <>
            <Grid style={{ background: '#F2F4F7', padding: '10px 20px' }}>
              <Grid style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                <Grid style={{ width: '47%' }}>
                  <Typography className={classes.required_field}>No. of Questions in the Pre Assessment</Typography>

                  <input
                    type="number"
                    placeholder="ex. 25"
                    className={classes.inputField}
                    value={totalQuestion}
                    onChange={(e) => {
                      const inp = e.target.value;
                      if (inp >= 0) {
                        setTotalQeustion(inp);
                      }
                    }}
                  />
                </Grid>
                <Grid style={{ width: '47%' }}>
                  <Typography className={classes.optional_field}>If failed, lock exam for</Typography>
                  <Grid
                    style={{
                      width: '100%',
                      display: 'flex',
                    }}
                  >
                    <input
                      placeholder="ex. 48"
                      className={classes.inputFieldTime}
                      type="number"
                      value={lockTime}
                      onChange={(e) => {
                        const inp = e.target.value;
                        if (inp >= 0) {
                          setLockTime(e.target.value);
                        }
                      }}
                    />
                    <Select
                      className={classes.select}
                      onChange={(e) => setTimeUnit(e.target.value)}
                      value={timeUnit}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    >
                      {LOCK_TIME_UNITS?.map((data) => (
                        <MenuItem value={data} key={data}>
                          {data}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                </Grid>
              </Grid>
              <Grid style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                <Grid style={{ width: '47%' }}>
                  <Typography className={classes.required_field} style={{ marginBottom: '5px' }}>
                    Exam Start Date
                  </Typography>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      placeholder="YYYY-MM-DD"
                      value={dates.startDate}
                      onChange={handleStartDateChange}
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: 'date-field',
                        },
                      }}
                      format="yyyy-MM-dd"
                      style={{
                        width: '95%',
                        backgroundColor: 'white',
                        height: '35px',
                        borderRadius: 8,
                        padding: '10px',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>

                <Grid style={{ width: '47%' }}>
                  <Typography className={classes.required_field} style={{ marginBottom: '5px' }}>
                    Exam End Date
                  </Typography>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      placeholder="YYYY-MM-DD"
                      value={dates.endDate}
                      onChange={handleEndDateChange}
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: 'date-field',
                        },
                      }}
                      format="yyyy-MM-dd"
                      style={{
                        width: '95%',
                        backgroundColor: 'white',
                        height: '35px',
                        borderRadius: 8,
                        padding: '10px',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
              <Grid style={{ width: '97%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                <Grid style={{ width: '47%' }}>
                  <Typography className={classes.optional_field}>Passing Score (in percentage)</Typography>
                  <input
                    placeholder="ex. 80"
                    type="number"
                    className={classes.inputField}
                    value={passingScore}
                    onChange={(e) => {
                      const inp = e.target.value;
                      if (inp >= 0) {
                        setPassingScore(e.target.value);
                      }
                    }}
                  />
                </Grid>
              </Grid>
              <Grid style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                <Grid container style={{ width: '47%', alignItems: 'center' }}>
                  <Typography className={classes.required_field} style={{ marginBottom: '5px', marginRight: '20px' }}>
                    Allow users to skip journeys
                  </Typography>
                  <AntSwitch
                    checked={enableAllowSkipJourney}
                    onChange={handleAllowSkipJourneyChange}
                    inputProps={{ 'aria-label': 'ant design' }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <QuestionList
              setIsAddQuestion={setIsAddQuestion}
              questions={questions}
              setQeustions={setquestions}
              setIsEdit={setIsQEdit}
              setSelectedIndex={setSelectedIndex}
              calledFrom="collectionAssesment"
              journeys={journeys}
              //   remove
              selectedIndex={selectedIndex}
              isQEdit={isQEdit}
            />
          </>
        )}

        <Grid style={{ display: 'flex' }}>
          {isAddQuestion && (
            <Button
              onClick={() => {
                setIsAddQuestion(false);
                clearState();
              }}
              variant="outlined"
            >
              Back
            </Button>
          )}
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
            <>
              <Button onClick={() => setIsOpen(false)} variant="outlined">
                Cancel
              </Button>
              {isAddQuestion ? (
                <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={onAdd}>
                  Add
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: '10px' }}
                  onClick={() => {
                    if (isEdit) {
                      onEditSubmit();
                    } else {
                      onSubmit();
                    }
                  }}
                >
                  Save
                </Button>
              )}
            </>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
